import script from "./AtomInputColor.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomInputColor.vue?vue&type=script&lang=ts&setup=true"

import "./AtomInputColor.vue?vue&type=style&index=0&id=2d1e2538&lang=css"
import "./AtomInputColor.vue?vue&type=style&index=1&id=2d1e2538&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d1e2538"]])

export default __exports__